import * as swcHelpers from '@swc/helpers';
import { validateResponse } from '../../response.js';
import { acceptJson, postJson, authHeader } from '../../shared.js';
import { addressContainerSpec } from './specs.js';

const create = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apiUrl, { customerId , accessToken , address  }) {
        return validateResponse(addressContainerSpec, (yield fetch(`${apiUrl}/customers/customers/${encodeURIComponent(customerId)}/addresses`, {
            method: 'POST',
            headers: swcHelpers.objectSpread({}, acceptJson, postJson, authHeader(accessToken)),
            body: JSON.stringify(address)
        })));
    });
    return function create(apiUrl, _) {
        return _ref.apply(this, arguments);
    };
}();

export { create };
//# sourceMappingURL=create.js.map
